import AdministrationTypes from "Containers/Administration/types"
//***************************************************/
//***                ORGANIGRAMME                 ***/
//***************************************************/
export const getOrganigrammeAction = payload => ({
  type: AdministrationTypes.GET_ORGANIGRAMME,
  payload,
})

export const getOrganigrammeSuccessAction = payload => ({
  type: AdministrationTypes.GET_ORGANIGRAMME_SUCCESS,
  payload,
})

export const postOrganigrammeAction = payload => ({
  type: AdministrationTypes.POST_ORGANIGRAMME,
  payload,
})

export const postOrganigrammeSuccessAction = payload => ({
  type: AdministrationTypes.POST_ORGANIGRAMME_SUCCESS,
  payload,
})

export const patchOrganigrammeAction = payload => ({
  type: AdministrationTypes.PATCH_ORGANIGRAMME,
  payload,
})

export const patchOrganigrammeSuccessAction = payload => ({
  type: AdministrationTypes.PATCH_ORGANIGRAMME_SUCCESS,
  payload,
})

export const deleteOrganigrammeAction = payload => ({
  type: AdministrationTypes.DELETE_ORGANIGRAMME,
  payload,
})

export const deleteOrganigrammeSuccessAction = payload => ({
  type: AdministrationTypes.DELETE_ORGANIGRAMME_SUCCESS,
  payload,
})

//***************************************************/
//***                UTILISATEURS                 ***/
//***************************************************/
export const getUsersAction = payload => ({
  type: AdministrationTypes.GET_USERS,
  payload,
})

export const getUsersSuccessAction = payload => ({
  type: AdministrationTypes.GET_USERS_SUCCESS,
  payload,
})

export const postUsersAction = payload => ({
  type: AdministrationTypes.POST_USERS,
  payload,
})

export const postUsersSuccessAction = payload => ({
  type: AdministrationTypes.POST_USERS_SUCCESS,
  payload,
})

export const patchUsersAction = payload => ({
  type: AdministrationTypes.PATCH_USERS,
  payload,
})

export const patchUsersSuccessAction = payload => ({
  type: AdministrationTypes.PATCH_USERS_SUCCESS,
  payload,
})

export const deleteUsersAction = payload => ({
  type: AdministrationTypes.DELETE_USERS,
  payload,
})

export const deleteUsersSuccessAction = payload => ({
  type: AdministrationTypes.DELETE_USERS_SUCCESS,
  payload,
})
//***************************************************/
//***                 PROFILS                     ***/
//***************************************************/
export const getProfilsAction = payload => ({
  type: AdministrationTypes.GET_PROFILS,
  payload,
})

export const getProfilsSuccessAction = payload => ({
  type: AdministrationTypes.GET_PROFILS_SUCCESS,
  payload,
})

export const postProfilsAction = payload => ({
  type: AdministrationTypes.POST_PROFILS,
  payload,
})

export const postProfilsSuccessAction = payload => ({
  type: AdministrationTypes.POST_PROFILS_SUCCESS,
  payload,
})

export const patchProfilsAction = payload => ({
  type: AdministrationTypes.PATCH_PROFILS,
  payload,
})

export const patchProfilsSuccessAction = payload => ({
  type: AdministrationTypes.PATCH_PROFILS_SUCCESS,
  payload,
})

export const deleteProfilsAction = payload => ({
  type: AdministrationTypes.DELETE_PROFILS,
  payload,
})

export const deleteProfilsSuccessAction = payload => ({
  type: AdministrationTypes.DELETE_PROFILS_SUCCESS,
  payload,
})
